"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigRegistry = void 0;
const fs = __importStar(require("fs-extra"));
const path = __importStar(require("path"));
const os = __importStar(require("os"));
const yaml = __importStar(require("yaml"));
const dist_1 = require("../../../core/dist");
const CONFIG_DIR = path.join(os.homedir(), '.loom');
const CONFIG_PATH = path.join(CONFIG_DIR, 'config.yaml');
function normalizePath(p) {
    return p.replace(/\\/g, '/');
}
class ConfigRegistry {
    constructor() {
        this.registry = this.load();
    }
    load() {
        if (!fs.existsSync(CONFIG_PATH)) {
            return { active_loom: null, looms: [] };
        }
        const content = fs.readFileSync(CONFIG_PATH, 'utf8');
        return yaml.parse(content) || { active_loom: null, looms: [] };
    }
    save() {
        fs.ensureDirSync(CONFIG_DIR);
        fs.writeFileSync(CONFIG_PATH, yaml.stringify(this.registry));
    }
    getActiveLoom() {
        return this.registry.active_loom;
    }
    setActiveLoom(name) {
        const loom = this.registry.looms.find(l => l.name === name);
        if (!loom) {
            throw new Error(`Loom '${name}' not found`);
        }
        this.registry.active_loom = loom.path;
        this.save();
    }
    addLoom(name, customPath) {
        let relativePath;
        if (customPath) {
            relativePath = path.relative(CONFIG_DIR, customPath);
        }
        else {
            relativePath = path.join('..', 'looms', name);
        }
        relativePath = normalizePath(relativePath);
        const existing = this.registry.looms.find(l => l.name === name);
        if (existing) {
            throw new Error(`Loom '${name}' already exists`);
        }
        this.registry.looms.push({
            name,
            path: relativePath,
            created: (0, dist_1.nowIso)(),
        });
        this.save();
    }
    listLooms() {
        return this.registry.looms;
    }
    resolveLoomPath(relativePath) {
        return path.resolve(CONFIG_DIR, relativePath);
    }
    /**
     * Determines whether the current context is a mono‑loom (local .loom/ found)
     * or multi‑loom (relying on global registry).
     */
    isMonoLoom() {
        let currentDir = process.cwd();
        while (true) {
            if (fs.existsSync(path.join(currentDir, '.loom'))) {
                return true;
            }
            const parentDir = path.dirname(currentDir);
            if (parentDir === currentDir)
                break;
            currentDir = parentDir;
        }
        return false;
    }
    /**
     * Returns the path to the local mono‑loom if one is found.
     */
    getMonoLoomPath() {
        let currentDir = process.cwd();
        while (true) {
            const loomDir = path.join(currentDir, '.loom');
            if (fs.existsSync(loomDir)) {
                return currentDir;
            }
            const parentDir = path.dirname(currentDir);
            if (parentDir === currentDir)
                break;
            currentDir = parentDir;
        }
        return null;
    }
    /**
     * Returns the name of the currently active loom, or null if none is set.
     */
    getActiveLoomName() {
        const active = this.registry.active_loom;
        if (!active)
            return null;
        const loom = this.registry.looms.find(l => l.path === active);
        return loom?.name || null;
    }
    /**
     * Removes all registry entries whose paths no longer exist on disk.
     */
    cleanup() {
        const validLooms = this.registry.looms.filter(loom => {
            const resolved = this.resolveLoomPath(loom.path);
            return fs.existsSync(resolved);
        });
        const removedCount = this.registry.looms.length - validLooms.length;
        this.registry.looms = validLooms;
        // If the active loom was removed, clear it
        if (this.registry.active_loom) {
            const activeExists = validLooms.some(l => l.path === this.registry.active_loom);
            if (!activeExists) {
                this.registry.active_loom = null;
            }
        }
        if (removedCount > 0) {
            this.save();
        }
    }
}
exports.ConfigRegistry = ConfigRegistry;
